import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrgService } from '../../core/services/org.service';
import { AuthService } from '../../core/services/auth.service';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-accept-invite',
  templateUrl: './accept-invite.component.html',
})
export class AcceptInviteComponent implements OnInit {
  state: 'checking' | 'accepting' | 'success' | 'error' | 'unauthenticated' = 'checking';
  errorMessage = '';
  orgName = '';

  private token = '';

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly orgService: OrgService,
    private readonly auth: AuthService,
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token') ?? '';

    if (!this.token) {
      this.errorMessage = 'No invitation token found. Please use the link from your invitation email.';
      this.state = 'error';
      return;
    }

    // Check authentication before attempting acceptance
    this.auth.currentUser$.pipe(take(1)).subscribe(user => {
      if (!user) {
        this.state = 'unauthenticated';
        return;
      }
      this.acceptInvite();
    });
  }

  acceptInvite(): void {
    this.state = 'accepting';

    this.orgService.acceptInvitation(this.token).subscribe({
      next: res => {
        this.orgName = res.org.name;
        this.state = 'success';
      },
      error: (err: { status: number; error?: { message?: string } }) => {
        if (err.status === 410) {
          this.errorMessage = 'This invitation has expired. Please ask your team admin to send a new one.';
        } else if (err.status === 409) {
          this.errorMessage = 'This invitation has already been used or you are already a member.';
        } else if (err.status === 403) {
          this.errorMessage = 'This invitation was sent to a different email address. Please sign in with the correct account.';
        } else if (err.status === 404) {
          this.errorMessage = 'Invitation not found. It may have been revoked.';
        } else {
          this.errorMessage = err?.error?.message ?? 'Something went wrong. Please try again or contact support.';
        }
        this.state = 'error';
      },
    });
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }

  goToSignIn(): void {
    this.router.navigate(['/login'], { queryParams: { returnUrl: `/accept-invite?token=${this.token}` } });
  }

  goToSignUp(): void {
    this.router.navigate(['/signup'], { queryParams: { returnUrl: `/accept-invite?token=${this.token}` } });
  }
}
